module.exports=function(scope){ return `<div style="padding: 15px;">${scope.msg1}</div>

<div style="text-align: center;">
    <button id="asseco-rds-contract-download" class="mdl-button mdl-button--colored mdl-button--raised">${scope.btnTxt}</button>
</div>

<div style="padding: 25px 15px 25px 15px;">${scope.msg2}</div>`};